import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  // Converts the errors on the page (in JSON form) into contextual errors
  // that attach next to the affected field.
  // This is a more general form of /views/validate.js.erb,
  // which is used exclusively for admin remote forms that
  // have well-defined models.
  connect() {
    const this_ = this;

    if ($("#errors-on-page").length == 0) return;

    // errors' keys are all Field names
    var errors = $.parseJSON($("#errors-on-page").html());

    // Clear all contextual form errors
    $('.form-row').removeClass('error').find('.message').removeClass('alert-text-color').html('');

    $.each(errors, function(key, value) {
      // Normal fields
      let input = document.querySelector(`[name="${key}"]`)
      if (input) {
        input.setAttribute('aria-invalid', 'true')
        const form_row = input.closest('.form-row')
        this_.attach_error_to_container(form_row, value)
        return
      }

      // Field array (could be checkbox list or multiselect or subfield of n-group)
      input = document.querySelector(`[name="${key}[]"]`)
      if (input) {
        if (this_.is_subfield_key(key)) {
          // subfield
          const form_row = input.closest('.form-row')
          this_.attach_error_to_container(form_row, value)
        } else if (this_.is_checkbox(input)) {
          // checkbox list
          const fieldset = input.closest('fieldset')
          fieldset.setAttribute('aria-invalid', 'true')
          this_.attach_error_to_container(fieldset, value)
        } else {
          // multiselect
          this_.attach_error_to_container(input.closest('.form-row'), value)
        }
        return
      }

      // n-group
      const ngroup = document.getElementById(`n-group-${key}`)
      if (ngroup) {
        this_.attach_error_to_container(ngroup, value)
        return
      }
    });

//     // Adds focus to the error notification at the top so the voice over can read it
//     // TODO: I thought with the appropriate aria attributes, this should be unnecessary
//     $('#main-alerts').attr('tabindex', '0');
//     $('#main-alerts').focus();
  }

  attach_error_to_container(container, errors) {
    container.classList.add('error')

    const message_element = container.querySelector('.message')
    message_element.classList.add('alert-text-color')

    message_element.innerHTML = '<div>' + errors.join('</div><div>') + '</div>'
  }

  is_checkbox(element) {
    return element.tagName === 'INPUT' && element.type === 'checkbox'
  }

  is_subfield_key(key) {
    return /\[\d+\]$/.test(key)
  }
}
